import {
  AuthResponse,
  SignMessageResponse,
  AuthResponseData,
  SignMessageResponseData,
} from 'dapp'
import { base64URLStringToBuffer, bufferToHex } from 'utils'

export const formatResponse = <T extends AuthResponse | SignMessageResponse>(
  res: AuthResponse | SignMessageResponse
) => {
  const { error, data } = res
  if (error !== undefined) {
    return res
  }
  const { message, signature } = data
  const newData: AuthResponseData | SignMessageResponseData = {
    ...data,
  }
  if (message) {
    newData.message = bufferToHex(base64URLStringToBuffer(message))
  }
  if (signature) {
    newData.signature = bufferToHex(base64URLStringToBuffer(signature))
  }
  return {
    type: res.type,
    data: newData,
  } as T
}
